import React from "react";
import { Link } from "react-router-dom";
import "../Guides/guides.css"; // Optional: add your custom styling here
import "./notFound.css"; // Optional: add your custom styling here

const NotFound = () => (
  <div className="guides-content guides-content-pad not-found">
    <h1>404</h1>
    <h3>Whoops, something ain't right...</h3>
    <p>
      Let's go back to the homepage, or check the URL.
    </p>
    <Link to="/"><button>Go back home</button></Link>
  </div>
);

export default NotFound;
